require('dom-slider');
import throttle from 'lodash/throttle';

const { slideToggle } = window.domSlider;

const tablesFlip = document.querySelectorAll('.wp-block-table.is-style-flip');
const tablesStack = document.querySelectorAll('.wp-block-table.is-style-stack');
const tablesPipeline = document.querySelectorAll(
	'.wp-block-table.is-style-pipeline'
);
const pipelineContents = document.querySelectorAll(
	'.wp-block-table__pipeline-content'
);

const pipelineContentButtons = [];

if (tablesFlip.length > 0) {
	tablesFlip.forEach((table) => {
		const firstRowItems = table.querySelectorAll('tbody td');

		if (firstRowItems.length > 0) {
			firstRowItems.forEach((firstRowItem, index) => {
				const items = table.querySelectorAll(
					'th:nth-child(' +
						(index + 1) +
						'), td:nth-child(' +
						(index + 1) +
						')'
				);

				if (items.length > 0) {
					items.forEach((item) => {
						item.style.setProperty('--mobileRow', index + 1);
					});
				}
			});
		}
	});
}

if (tablesStack.length > 0) {
	tablesStack.forEach((table) => {
		const headings = table.querySelectorAll('thead th');

		if (headings.length > 0) {
			headings.forEach((heading, index) => {
				const items = table.querySelectorAll(
					'td:nth-child(' + (index + 1) + ')'
				);

				if (items.length > 0) {
					items.forEach((item) => {
						const label = document.createElement('div');
						const text = document.createTextNode(heading.innerText);
						label.classList.add('wp-block-table__mobile-label');

						label.appendChild(text);
						item.insertBefore(label, item.firstChild);
					});
				}
			});
		}
	});
}

if (tablesPipeline.length > 0) {
	tablesPipeline.forEach((table) => {
		const headings = table.querySelectorAll('thead th');
		const rows = table.querySelectorAll('tr');

		if (rows.length > 0) {
			rows.forEach((row) => {
				const progressCells = row.querySelectorAll(
					'.wp-block-table__pipeline-progress-cell'
				);

				if (progressCells.length > 0) {
					progressCells[progressCells.length - 1].classList.add(
						'wp-block-table__pipeline-progress-cell--last'
					);

					if (headings.length > 0) {
						progressCells[
							progressCells.length - 1
						].style.setProperty(
							'--mobileWidth',
							`${(progressCells.length / (headings.length - progressCells[0].cellIndex)) * 100}%`
						);

						if (
							headings[
								progressCells[progressCells.length - 1]
									.cellIndex
							]
						) {
							const label = document.createElement('div');
							const text = document.createTextNode(
								headings[
									progressCells[progressCells.length - 1]
										.cellIndex
								].innerText
							);
							label.classList.add('wp-block-table__mobile-label');

							label.appendChild(text);
							progressCells[progressCells.length - 1].appendChild(
								label
							);
						}
					}
				}
			});
		}
	});
}

const togglePipelineButton = (e) => {
	e.preventDefault();

	if (
		!e.currentTarget.classList.contains(
			'wp-block-table__pipeline-content-button--opening'
		)
	) {
		e.currentTarget.classList.toggle('active');
		e.currentTarget.classList.add(
			'wp-block-table__pipeline-content-button--opening'
		);

		const currentContent = e.currentTarget.nextElementSibling;

		currentContent.classList.remove(
			'wp-block-table__pipeline-content--hidden'
		);

		slideToggle({
			element: currentContent,
			slideSpeed: 400,
			easing: 'ease-in-out',
		}).then((contentElement) => {
			if (contentElement.classList.contains('DOM-slider-hidden')) {
				contentElement.classList.add(
					'wp-block-table__pipeline-content--hidden'
				);
			}

			const buttonElement = contentElement.previousElementSibling;

			if (buttonElement) {
				buttonElement.classList.remove(
					'wp-block-table__pipeline-content-button--opening'
				);
			}
		});
	}
};

const setContentButtonHeight = () => {
	pipelineContentButtons.forEach((pipelineContentButton) => {
		pipelineContentButton.style.setProperty('--tableCellHeight', `0rem`);

		pipelineContentButton.style.setProperty(
			'--tableCellHeight',
			`${(pipelineContentButton.parentElement.offsetHeight - pipelineContentButton?.nextElementSibling.offsetHeight) / 16}rem`
		);
	});
};

if (pipelineContents.length > 0) {
	pipelineContents.forEach((content) => {
		let prev = content.previousSibling;
		const nodesToWrap = [];

		while (prev) {
			if (
				prev.nodeType === Node.ELEMENT_NODE ||
				prev.nodeType === Node.TEXT_NODE
			) {
				nodesToWrap.unshift(prev);
			} else {
				break;
			}
			prev = prev.previousSibling;
		}

		if (nodesToWrap.length > 0) {
			const button = document.createElement('button');
			button.setAttribute('type', 'button');
			button.className = 'wp-block-table__pipeline-content-button';

			nodesToWrap[0].parentNode.insertBefore(button, nodesToWrap[0]);

			nodesToWrap.forEach((node) => {
				button.appendChild(node);
			});

			button.addEventListener('click', togglePipelineButton);

			pipelineContentButtons.push(button);
		}
	});

	window.addEventListener('resize', throttle(setContentButtonHeight, 100));
	setContentButtonHeight();
}
